import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Components //
import View from 'components/View';
import Fill from 'components/Fill';
import Button from 'components/Button';
import LoadingSpinner from 'components/LoadingSpinner';

const Root = styled(View)`
  flex-direction: row;
  align-items: center;
  padding: 48px 0px 32px;
`;

const LoadingWrapper = styled(View)`
  width: 80px;
  height: 32px;
  justify-content: center;
  align-items: center;
`;

const StepFooter = ({
  disableNext,
  disablePrev,
  loading,
  nextLabel,
  prevLabel,
  onNextClick,
  onPrevClick,
  ...rest
}) => {
  return (
    <Root {...rest}>
      <Button
        disabled={disablePrev}
        type="outlined"
        label={prevLabel}
        onClick={onPrevClick}
      />
      <Fill />
      {!loading && <Button
        disabled={disableNext}
        label={nextLabel}
        onClick={onNextClick}
      />}
      {loading && (
        <LoadingWrapper>
          <LoadingSpinner speed={1000} width={20} height={20} />
        </LoadingWrapper>
      )}
    </Root>
  );
}

StepFooter.propTypes = {
  nextLabel: PropTypes.string,
  prevLabel: PropTypes.string,
  onNextClick: PropTypes.func.isRequired,
  onPrevClick: PropTypes.func.isRequired,
};

StepFooter.defaultProps = {
  nextLabel: 'Next',
  prevLabel: 'Back',
}

export default StepFooter;
